export default "__VITE_ASSET__D5ow5zZS__"